import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: string): string {
    const dateInput = new Date(value);
    const currentDate = new Date();
    const differenceInSeconds = (currentDate.getTime() - dateInput.getTime()) / 1000;

    if (differenceInSeconds < 3600) {
      const minutesAgo = differenceInSeconds / 60;
      return `${Math.floor(minutesAgo)} minutes ago`;
    }
    else if (differenceInSeconds < 86400) {
      const hoursAgo = differenceInSeconds / 3600;
      return `${Math.floor(hoursAgo)} hours ago`;
    }
    else {
      const differenceInDays = Math.floor(differenceInSeconds / 86400);
      return `${differenceInDays} days ago`;
    }
  }
}
